// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss'

import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import ElementUi from 'element-ui'
import GlobalConfig from '@/config'
import HttpRequest from '@/utils/HttpRequest'
import icon from 'vue-svg-icon/Icon'
import VueAMap from 'vue-amap'

Vue.config.productionTip = false
Vue.use(GlobalConfig)
Vue.use(ElementUi)
Vue.use(HttpRequest)
Vue.component('icon', icon)
Vue.use(VueAMap)

VueAMap.initAMapApiLoader({
  key: '619cb9591c520005263e42e5d2ab5942',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geolocation',
    'AMap.Geocoder',
    'AMap.MarkerClusterer'
  ]
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js